import { ref } from "vue";
import { defineStore } from "pinia";
import { State } from "@/interfaces/state";

export const useStateStore = defineStore("states", () => {
    const states = ref<State[]>([]);

    return {
        states,

        getState(name: string) {
            return states.value.find((state) => state.name === name);
        },

        setStates(value: State[]) {
            states.value = value;
        },
    };
});
